// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/index.scss
// module id = 3
// module chunks = 0